/* eslint-disable max-len */
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback } from 'react';

const styles = {
  center: css({
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    display: 'flex',
    '& .MuiFormControl-root': {
      width: '450px',
      margin: '0.5rem',
    }
  }),
  container: css({
    textAlign: 'center',
  }),
  title: css({
    fontSize: '3rem',
    lineHeight: '1',
  }),
  loginButton: css({
    padding: '1rem',
    width: '300px',
    margin: '3rem',
  }),
};

function View({ onClick }) {
  return (
    <div css={styles.center}>
      <div css={styles.container}>
        <h1 css={styles.title}>🚀 Stratosphere Login Utility 🚀</h1>
        <div>
          <Button variant="contained" css={styles.loginButton} onClick={onClick} type="button">Login</Button>
        </div>
      </div>
    </div>
  );
}

function Model() {
  const onClick = useCallback(() => {
    window.location.href = `
      ${process.env.REACT_APP_OAUTH_SERVER}/oauth/authenticate?response_type=code&client_id=${process.env.REACT_APP_OAUTH_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_OAUTH_REDIRECT_URL}&scope=read%20document.upload%20folder.create&state=none
    `;
  }, []);

  const hookProps = {
    onClick,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
